import React from "react";
import { Link, withRouter } from "react-router-dom";

const ExpiredJob = (props) => {

	return (
		<div id="expiredJobDiv">
			<div className="mainContent">
				<div className="row">
					<div className="col-sm-10 col-sm-offset-1">
							<div className="jobContentWrapper">
								<h3>Sorry, the job you are looking for does not exist anymore.</h3>
								<h6>Search for more available jobs <a href="https://www.upward.careers/results/?pageNum=1">here</a>.</h6>
							</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default withRouter(ExpiredJob);
